import Swiper from '~/swiper';
import { Navigation, Pagination } from '~/swiper/modules';
import PhotoSwipeLightbox from '~/photoswipe/dist/photoswipe-lightbox.esm.js';

class GewobagGallery {
	constructor(gallery) {
		this.gallery = gallery;
		this.initSwiper();
		this.initPhotoSwipe();
	}

	initSwiper() {
		this.swiper = new Swiper(this.gallery, {
			modules: [Navigation, Pagination],
			slidesPerView: 1,
			spaceBetween: 0,
			speed: 1000,
			centeredSlides: true,
			grabCursor: true,
			autoHeight: true,
			loop: false,
			autoplay: false,
			keyboard: {
				enabled: true,
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			pagination: {
				el: ".swiper-pagination",
				type: "fraction",
				renderFraction: (currentClass, totalClass) => `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`,
			},
		});
	}

	initPhotoSwipe() {
		this.lightbox = new PhotoSwipeLightbox({
			gallery: this.gallery,
			children: '.js-gallery-link',
			pswpModule: () => import('~/photoswipe/dist/photoswipe.esm.js'),
			initialZoomLevel: 'fit',
			maxZoomLevel: 1,
			showHideAnimationType: 'zoom',
			bgOpacity: 0.9,
			allowZoom: false,
		});

		this.lightbox.addFilter('itemData', (itemData, index) => {
			const link = itemData.element;
			const img = link.querySelector('img');

			if (img) {
				itemData.src = link.href;
				itemData.width = parseInt(img.getAttribute('width')) || img.naturalWidth || 1920;
				itemData.height = parseInt(img.getAttribute('height')) || img.naturalHeight || 1080;
				itemData.alt = img.alt || '';
			}

			return itemData;
		});

		this.lightbox.init();

		this.lightbox.on('closingAnimationStart', () => {
			const { pswp } = this.lightbox;
			this.swiper.slideTo(pswp.currIndex, 0, false);
		});
	}
}

export default GewobagGallery;
